import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { H6 } from 'foundations-components/transitional/components/H6';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useContext } from 'react';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { AppContext } from '../../contexts/app/context';
import { ContactsPropsContext } from '../../contexts/contacts/PropsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AttendeePrompt() {
  const {
    myParticipantUUID,
    usageTracker,
    methods,
    coHostRequestSent,
    isLoading
  } = useContext(ContactsPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const sendCoHostRequestHandler = () => {
    if (myParticipantUUID) {
      usageTracker.trackInteraction(Object.assign({
        screen: SCREENS.participants
      }, ACTIONS.participants.clickSendNotification));
      methods.sendCoHostRequest(myParticipantUUID);
    }
  };
  return /*#__PURE__*/_jsxs(Box, {
    marginInline: "500",
    marginBlock: "600",
    children: [/*#__PURE__*/_jsx(H6, {
      children: /*#__PURE__*/_jsx(BreakString, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.attendee.participants"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(BreakString, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: coHostRequestSent ? 'contactList.attendee.coHostRequestSentText' : 'contactList.attendee.coHostRequestText'
        })
      })
    }), /*#__PURE__*/_jsx(LoadingButton, {
      use: "primary",
      disabled: coHostRequestSent,
      onClick: sendCoHostRequestHandler,
      loading: isLoading,
      "data-test-id": `${appName}-request-co-host-button`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contactList.attendee.coHostRequestButton"
      })
    })]
  });
}
export default AttendeePrompt;